import { createFileRoute } from '@tanstack/react-router'

import { WhatsAppGroupsPage } from '@/features/connect/components/WhatsAppGroupsPage'
import { whatsAppGroupsQueryOptions } from '@/features/group/queries'

export const Route = createFileRoute('/_authed/groups')({
  loader: async ({ context }) => {
    await context.queryClient.prefetchInfiniteQuery(whatsAppGroupsQueryOptions())
  },
  component: WhatsAppGroupsPage,
})
